var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ErrorType } from "./IUtilityTypes";
import ConsoleHelper from "./ConsoleHelper";
import EventDriver from "./EventDriver";
/**
 * 函数执行装饰器
 */
var EventHelper = /** @class */ (function () {
    function EventHelper() {
    }
    /**
     * 执行一段普通函数代码
     *
     * 使用：`@EventHelper.exec()`
     */
    EventHelper.exec = function (message, errorText) {
        if (message === void 0) { message = ConsoleHelper; }
        if (errorText === void 0) { errorText = "数据获取失败,请联系系统管理员！"; }
        return function decorator(target, name, descriptor) {
            var original = descriptor.value;
            if (typeof original === "function") {
                descriptor.value = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(this, void 0, void 0, function () {
                        var result, e_1, errorType;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, original.apply(this, args)];
                                case 1:
                                    result = _a.sent();
                                    return [2 /*return*/, result];
                                case 2:
                                    e_1 = _a.sent();
                                    if (e_1) {
                                        errorType = ErrorType.unknown;
                                        errorText = e_1.message || errorText;
                                        if (e_1.success === false) {
                                            errorText = e_1.message;
                                            errorType = ErrorType.known;
                                            if (e_1.errorType) {
                                                errorType = e_1.errorType;
                                            }
                                        }
                                        message.error(errorText, e_1);
                                        EventDriver.send("catchError", {
                                            errorText: errorText,
                                            errorType: errorType,
                                            errorMessage: e_1
                                        });
                                    }
                                    throw e_1;
                                case 3: return [2 /*return*/];
                            }
                        });
                    });
                };
            }
            return descriptor;
        };
    };
    /**
     * 执行一段普通函数代码，并对该函数加锁
     *
     * 使用：`@EventHelper.execLock()`
     * @param errorText 出现错误时得提示信息文本
     */
    EventHelper.execLock = function (message, errorText) {
        if (message === void 0) { message = ConsoleHelper; }
        if (errorText === void 0) { errorText = "未知错误"; }
        return function decorator(target, name, descriptor) {
            var original = descriptor.value;
            if (typeof original === "function") {
                descriptor.value = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(this, void 0, void 0, function () {
                        var result, e_2, errorType;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    EventHelper.increaseLock();
                                    return [4 /*yield*/, original.apply(this, args)];
                                case 1:
                                    result = _a.sent();
                                    EventHelper.decreaseLock();
                                    return [2 /*return*/, result];
                                case 2:
                                    e_2 = _a.sent();
                                    EventHelper.decreaseLock();
                                    if (e_2) {
                                        errorType = ErrorType.unknown;
                                        errorText = e_2.message || errorText;
                                        if (e_2.success === false) {
                                            errorText = e_2.message;
                                            errorType = ErrorType.known;
                                            if (e_2.errorType) {
                                                errorType = e_2.errorType;
                                            }
                                        }
                                        message.error(errorText, e_2);
                                        EventDriver.send("catchError", {
                                            errorText: errorText,
                                            errorType: errorType,
                                            errorMessage: e_2
                                        });
                                    }
                                    throw e_2;
                                case 3: return [2 /*return*/];
                            }
                        });
                    });
                };
            }
            return descriptor;
        };
    };
    /**
     * 执行一段需要把数据提交到后端的函数代码，一般应用在点击提交按钮的场景中，例如：保存提货地址
     *
     * 多按钮状态设定, 通过监听 `lockSubmit` 事件，更新对应按钮状态
     * @param successText 请求成功时得提示信息文本,为`null`时不显示提示信息
     * @param errorText 出现错误时得提示信息文本
     * @returns 声明函数需返回`bool类型`，返回`true`为显示提示信息，当`successText`为`null`时即时返回`true`也不会显示提示信息
     */
    EventHelper.execSubmit = function (message, successText, errorText) {
        if (message === void 0) { message = ConsoleHelper; }
        if (successText === void 0) { successText = "保存成功"; }
        if (errorText === void 0) { errorText = "未知错误"; }
        return function decorator(target, name, descriptor) {
            var original = descriptor.value;
            if (typeof original === "function") {
                descriptor.value = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(this, void 0, void 0, function () {
                        var result, e_3, errorType;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    EventHelper.increaseLock();
                                    return [4 /*yield*/, original.apply(this, args)];
                                case 1:
                                    result = _a.sent();
                                    if (result && successText) {
                                        message.success(successText, 2, function () {
                                            EventHelper.decreaseLock();
                                        });
                                    }
                                    else {
                                        EventHelper.decreaseLock();
                                    }
                                    return [2 /*return*/, result];
                                case 2:
                                    e_3 = _a.sent();
                                    EventHelper.decreaseLock();
                                    if (e_3) {
                                        errorType = ErrorType.unknown;
                                        errorText = e_3.message || errorText;
                                        if (e_3.success === false) {
                                            errorText = e_3.message;
                                            errorType = ErrorType.known;
                                            if (e_3.errorType) {
                                                errorType = e_3.errorType;
                                            }
                                        }
                                        message.error(errorText, e_3);
                                        EventDriver.send("catchError", {
                                            errorText: errorText,
                                            errorType: errorType,
                                            errorMessage: e_3
                                        });
                                    }
                                    throw e_3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    });
                };
            }
            return descriptor;
        };
    };
    /**
     * 增加锁计数
     */
    EventHelper.increaseLock = function () {
        EventHelper._lockCount++;
    };
    /**
     * 减少锁计数
     */
    EventHelper.decreaseLock = function () {
        if (EventHelper._lockCount > 0) {
            EventHelper._lockCount--;
        }
    };
    /**
     * 当前缓存是否存在锁对象
     * @returns
     */
    EventHelper.prototype.isLock = function () {
        return EventHelper._lockCount !== 0;
    };
    EventHelper._lockCount = 0;
    return EventHelper;
}());
export default EventHelper;
